import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { AppletAuditTrailContainer } from '../../../../../../models';
import { ApiVisa, BasicApiResponseModel } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class AppletAuditTrailTenantEpService extends BaseApiTemplateService<AppletAuditTrailContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +'audit-trails/backoffice-ep';
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +'audit-trails/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +'audit-trails/backoffice-ep';
    this.httpClient = http;
  }

  /**
   * Get all audit trail data
   * @param visa API visa for authentication
   * @param criteria Criteria for filtering audit trail data
   * @returns Observable with audit trail data
   */
  public getAll(visa: ApiVisa, criteria: any): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    
    // Build query string directly from criteria
    let queryString = '';
    Object.keys(criteria).forEach(key => {
      if (criteria[key] !== undefined && criteria[key] !== null) {
        queryString += '&' + key + '=' + criteria[key];
      }
    });
    
    // Replace the first & with ? if there are parameters
    if (queryString) {
      queryString = '?' + queryString.substring(1);
    }
    
    const fullUrl = this.apiUrl + '/query' + queryString;
    
    return this.httpClient.get<BasicApiResponseModel<any>>(
      fullUrl,
      this.getHttpHeader(visa)
    );
  }
}